import type { Work } from "@/types";

export const works: Work[] = [
  {
    id: "m1",
    type: "movie",
    title: "沙漠孤星",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20astronaut%20standing%20on%20a%20vast%20orange%20desert%20planet%20under%20a%20deep%20navy%20starry%20sky%2C%20dramatic%20lighting%2C%20minimalist%20sci-fi%20aesthetic%2C%20soft%20gradient%20horizon%2C%20high%20detail%20editorial%20composition&width=400&height=600&seq=ya-movie-poster-01&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20an%20astronaut%20silhouette%20walking%20across%20an%20endless%20orange%20sand%20dune%20with%20deep%20blue%20twilight%20sky%20above%2C%20atmospheric%20sci-fi%20film%20frame%2C%20soft%20dust%20particles%2C%20high%20detail%20movie%20photography&width=1200&height=675&seq=ya-movie-still-01&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "剧情", "冒险"],
    director: "陈牧之",
    cast: ["林嘉树", "苏晚晴", "赵行舟"],
    rating: 8.6,
    releaseDate: "2025-07-18",
    duration: "142分钟",
    synopsis:
      "一名孤独的星际勘测员被困在资源枯竭的沙漠行星上，他必须依靠有限的补给与一段跨越光年的通讯，完成一场关于生存与信念的自我救赎。",
    airStatus: undefined,
  },
  {
    id: "m2",
    type: "movie",
    title: "长夜将尽",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20thriller%20movie%20poster%20with%20a%20rainy%20neon%20city%20alley%20at%20night%2C%20lone%20detective%20figure%20in%20dark%20navy%20coat%2C%20orange%20streetlamp%20glow%2C%20cinematic%20noir%20composition%2C%20high%20detail%2C%20moody%20atmosphere&width=400&height=600&seq=ya-movie-poster-02&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20still%20of%20a%20rain%20slicked%20city%20street%20at%20night%20with%20warm%20orange%20lamplight%20reflecting%20on%20wet%20asphalt%2C%20deep%20blue%20shadows%2C%20detective%20silhouette%20walking%20away%2C%20high%20detail%20film%20photography&width=1200&height=675&seq=ya-movie-still-02&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    director: "周砚青",
    cast: ["沈亦白", "何婉宁", "徐立"],
    rating: 8.9,
    releaseDate: "2025-09-05",
    duration: "128分钟",
    synopsis:
      "一桩尘封十年的旧案在长夜中被重新翻开，刑警老周发现线索竟指向自己最信任的搭档，真相与情义的抉择在黎明前展开。",
  },
  {
    id: "m3",
    type: "movie",
    title: "春日列车",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20art%20house%20movie%20poster%20of%20an%20old%20train%20window%20with%20soft%20pink%20cherry%20blossoms%20outside%2C%20warm%20sunlight%20streaks%2C%20gentle%20melancholic%20mood%2C%20minimal%20composition%2C%20delicate%20watercolor%20tone&width=400&height=600&seq=ya-movie-poster-03&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20film%20still%20of%20a%20young%20couple%20sitting%20in%20an%20old%20train%20carriage%20with%20cherry%20blossom%20petals%20drifting%20outside%20the%20window%2C%20soft%20spring%20golden%20light%2C%20quiet%20tender%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=ya-movie-still-03&orientation=landscape",
    year: 2024,
    region: "日本",
    genres: ["爱情", "文艺", "剧情"],
    director: "岩井俊介",
    cast: ["新垣結衣里", "松本和海", "高桥美咲"],
    rating: 8.2,
    releaseDate: "2024-04-12",
    duration: "118分钟",
    synopsis:
      "一趟驶向北海道的春日列车，让两位错过彼此的旧友再次相遇，他们用一路的风景与沉默，重新学会告别与释怀。",
  },
  {
    id: "m4",
    type: "movie",
    title: "山海异闻录",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20adventure%20movie%20poster%20with%20a%20mythical%20giant%20creature%20silhouette%20against%20a%20deep%20blue%20mountain%20range%20and%20glowing%20orange%20sky%2C%20ancient%20chinese%20ink%20painting%20style%2C%20dramatic%20scale%2C%20high%20detail&width=400&height=600&seq=ya-movie-poster-04&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20film%20still%20of%20a%20young%20adventurer%20facing%20a%20colossal%20ancient%20beast%20in%20a%20misty%20deep%20blue%20mountain%20valley%20with%20warm%20glowing%20runes%2C%20cinematic%20scale%2C%20high%20detail%20visual%20effects&width=1200&height=675&seq=ya-movie-still-04&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["奇幻", "冒险", "动作"],
    director: "陆沉",
    cast: ["顾云舟", "白若曦", "江凛"],
    rating: 7.9,
    releaseDate: "2025-08-01",
    duration: "136分钟",
    synopsis:
      "古籍《山海》中的异兽在现代城市苏醒，年轻的守山人必须集齐散落的神器，在异闻与现实交织的世界里守住两界的平衡。",
  },
  {
    id: "m5",
    type: "movie",
    title: "沉默的证词",
    poster:
      "https://readdy.ai/api/search-image?query=Tense%20courtroom%20drama%20movie%20poster%20with%20a%20single%20empty%20witness%20chair%20under%20a%20cold%20blue%20spotlight%2C%20shadowy%20figures%20in%20background%2C%20minimal%20suspenseful%20composition%2C%20high%20detail%2C%20serious%20tone&width=400&height=600&seq=ya-movie-poster-05&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Cinematic%20courtroom%20drama%20still%20of%20a%20lone%20lawyer%20standing%20in%20a%20large%20empty%20hall%20with%20tall%20windows%20casting%20cool%20blue%20light%2C%20quiet%20tension%2C%20high%20detail%20film%20photography%2C%20restrained%20palette&width=1200&height=675&seq=ya-movie-still-05&orientation=landscape",
    year: 2024,
    region: "中国香港",
    genres: ["悬疑", "剧情", "律政"],
    director: "黄启铭",
    cast: ["方中信华", "郑文静", "李国豪"],
    rating: 8.4,
    releaseDate: "2024-11-22",
    duration: "124分钟",
    synopsis:
      "一位坚持沉默的被告，一纸被撕毁的证词，让年轻律师踏上寻找真相之路——却发现法庭上最响亮的，往往是无人说出口的话。",
  },
  {
    id: "m6",
    type: "movie",
    title: "都市浮生",
    poster:
      "https://readdy.ai/api/search-image?query=Urban%20drama%20movie%20poster%20of%20a%20family%20silhouette%20standing%20on%20a%20high%20rise%20rooftop%20overlooking%20a%20warm%20orange%20sunset%20city%20skyline%2C%20deep%20blue%20evening%20tones%2C%20emotional%20composition%2C%20high%20detail&width=400&height=600&seq=ya-movie-poster-06&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Emotional%20family%20drama%20still%20of%20three%20generations%20sharing%20a%20meal%20in%20a%20modest%20city%20apartment%20at%20dusk%2C%20warm%20orange%20lamp%20glow%2C%20deep%20blue%20window%20light%2C%20tender%20intimate%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=ya-movie-still-06&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["剧情", "家庭", "现实"],
    director: "方建国",
    cast: ["濮存明", "刘兰芝", "陈小舟"],
    rating: 8.0,
    releaseDate: "2025-05-20",
    duration: "132分钟",
    synopsis:
      "一间即将拆迁的老楼里，三代人各自的烦恼在同一屋檐下交叠，平凡生活的褶皱里，藏着最动人的坚持与温情。",
  },
  {
    id: "m7",
    type: "movie",
    title: "极速边缘",
    poster:
      "https://readdy.ai/api/search-image?query=High%20octane%20racing%20action%20movie%20poster%20of%20a%20sleek%20sports%20car%20drifting%20with%20orange%20sparks%20and%20blurred%20motion%20on%20a%20deep%20blue%20night%20track%2C%20dynamic%20energy%2C%20high%20detail%20speed%20composition&width=400&height=600&seq=ya-movie-poster-07&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Adrenaline%20filled%20racing%20film%20still%20of%20two%20sports%20cars%20neck%20and%20neck%20on%20a%20wet%20night%20circuit%20with%20orange%20light%20trails%20and%20deep%20blue%20shadow%2C%20motion%20blur%2C%20cinematic%20high%20detail%20action%20photography&width=1200&height=675&seq=ya-movie-still-07&orientation=landscape",
    year: 2025,
    region: "韩国",
    genres: ["动作", "赛车", "犯罪"],
    director: "朴振宇",
    cast: ["李在勋", "金秀雅", "崔东贤"],
    rating: 7.6,
    releaseDate: "2025-06-27",
    duration: "116分钟",
    synopsis:
      "退役车手为救弟弟重返地下飙车圈，一场跨越国界的极速较量背后，是家族、背叛与重生的赛道人生。",
  },
  {
    id: "m8",
    type: "movie",
    title: "时光信箱",
    poster:
      "https://readdy.ai/api/search-image?query=Whimsical%20romantic%20fantasy%20movie%20poster%20of%20an%20old%20vintage%20mailbox%20glowing%20with%20warm%20orange%20light%20on%20a%20deep%20blue%20snowy%20evening%20street%2C%20dreamy%20magical%20mood%2C%20high%20detail%20illustration&width=400&height=600&seq=ya-movie-poster-08&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Dreamy%20romantic%20fantasy%20film%20still%20of%20a%20young%20woman%20holding%20a%20glowing%20letter%20beside%20an%20old%20mailbox%20on%20a%20snowy%20deep%20blue%20evening%20street%2C%20warm%20orange%20glow%2C%20magical%20tender%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=ya-movie-still-08&orientation=landscape",
    year: 2024,
    region: "中国台湾",
    genres: ["爱情", "奇幻", "治愈"],
    director: "林清和",
    cast: ["许静仪", "周子墨", "陈嘉玲"],
    rating: 8.3,
    releaseDate: "2024-12-24",
    duration: "110分钟",
    synopsis:
      "一个能寄信到过去的老信箱，让失意的女孩与十年前的自己通信，她在改写遗憾的过程中，也重新理解了爱与被爱。",
  },
  {
    id: "m9",
    type: "movie",
    title: "雾都迷案",
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20movie%20poster%20of%20a%20foggy%20old%20european%20city%20street%20with%20gas%20lamps%20glowing%20orange%20through%20deep%20blue%20mist%2C%20lone%20figure%20with%20umbrella%2C%20gothic%20suspense%20mood%2C%20high%20detail&width=400&height=600&seq=ya-movie-poster-09&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Gothic%20mystery%20film%20still%20of%20a%20detective%20examining%20clues%20in%20a%20fog%20filled%20old%20library%20with%20warm%20orange%20candlelight%20against%20deep%20blue%20shadows%2C%20tense%20atmosphere%2C%20high%20detail%20cinematic%20photography&width=1200&height=675&seq=ya-movie-still-09&orientation=landscape",
    year: 2025,
    region: "英国",
    genres: ["悬疑", "惊悚", "剧情"],
    director: "Alistair Cole",
    cast: ["William Hart", "Eleanor Reed", "James Whitfield"],
    rating: 8.1,
    releaseDate: "2025-03-14",
    duration: "126分钟",
    synopsis:
      "浓雾笼罩的港口城市接连发生离奇失踪案，退休警探与年轻记者联手追查，逐渐揭开一个跨越三十年的隐秘真相。",
  },
  {
    id: "m10",
    type: "movie",
    title: "稻香人家",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20rural%20drama%20movie%20poster%20of%20golden%20rice%20terraces%20at%20sunset%20with%20a%20farmer%20silhouette%2C%20deep%20blue%20distant%20mountains%2C%20nostalgic%20pastoral%20composition%2C%20soft%20painterly%20tones%2C%20high%20detail&width=400&height=600&seq=ya-movie-poster-10&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Nostalgic%20rural%20film%20still%20of%20a%20family%20harvesting%20rice%20in%20golden%20fields%20at%20sunset%20with%20a%20small%20village%20and%20deep%20blue%20mountains%20behind%2C%20warm%20pastoral%20atmosphere%2C%20high%20detail%20cinematic%20photography&width=1200&height=675&seq=ya-movie-still-10&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "乡土", "家庭"],
    director: "孙厚田",
    cast: ["王守义", "李桂香", "赵小禾"],
    rating: 7.8,
    releaseDate: "2023-10-06",
    duration: "121分钟",
    synopsis:
      "外出打工的青年回到即将空心化的家乡，在守住稻田与传统的过程中，重新找到自己与土地之间那条看不见的根。",
  },
  {
    id: "t1",
    type: "tv",
    title: "长安十二辰",
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20chinese%20historical%20drama%20poster%20of%20a%20lantern%20lit%20city%20gate%20at%20night%20with%20warm%20orange%20glow%20and%20deep%20blue%20sky%2C%20figures%20in%20tang%20dynasty%20robes%2C%20epic%20scale%2C%20high%20detail&width=400&height=600&seq=ya-tv-poster-01&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Epic%20tang%20dynasty%20series%20still%20of%20a%20grand%20lantern%20lit%20city%20street%20at%20night%20full%20of%20crowds%2C%20warm%20orange%20lights%20against%20deep%20blue%20sky%2C%20cinematic%20historical%20production%2C%20high%20detail&width=1200&height=675&seq=ya-tv-still-01&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["古装", "悬疑", "历史"],
    director: "章牧野",
    cast: ["萧景琰", "苏合香", "裴无咎"],
    rating: 9.1,
    releaseDate: "2025-02-08",
    duration: "45分钟/集",
    synopsis:
      "长安城在十二个时辰内将面临一场惊天密谋，守城小吏与天才少女携手，在有限的时间里追查线索、守护万家灯火。",
    seasons: 1,
    latestEpisode: 36,
    airStatus: "完结",
  },
  {
    id: "t2",
    type: "tv",
    title: "医心仁术",
    poster:
      "https://readdy.ai/api/search-image?query=Medical%20workplace%20drama%20poster%20of%20a%20dedicated%20doctor%20in%20blue%20scrubs%20backlit%20by%20warm%20orange%20hospital%20corridor%20light%2C%20clean%20modern%20composition%2C%20hopeful%20tone%2C%20high%20detail&width=400&height=600&seq=ya-tv-poster-02&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20series%20still%20of%20a%20team%20of%20doctors%20rushing%20through%20a%20bright%20hospital%20corridor%20with%20warm%20light%20and%20deep%20blue%20accents%2C%20urgent%20hopeful%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=ya-tv-still-02&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["医疗", "职场", "剧情"],
    director: "何青岑",
    cast: ["陆知远", "宋佳宁", "方致远"],
    rating: 8.7,
    releaseDate: "2025-04-15",
    duration: "42分钟/集",
    synopsis:
      "一群年轻医生在急诊科的高压日常中成长，他们在与时间赛跑的每一次抉择里，重新理解了医者仁心的重量。",
    seasons: 2,
    latestEpisode: 28,
    airStatus: "连载",
  },
  {
    id: "t3",
    type: "tv",
    title: "都市情缘",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20poster%20of%20a%20couple%20under%20city%20lights%20at%20dusk%2C%20warm%20orange%20glow%20and%20deep%20blue%20evening%20sky%2C%20stylish%20minimal%20composition%2C%20high%20detail&width=400&height=600&seq=ya-tv-poster-03&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Stylish%20urban%20romance%20series%20still%20of%20two%20young%20professionals%20talking%20on%20a%20rooftop%20terrace%20overlooking%20a%20city%20at%20dusk%2C%20warm%20orange%20lights%20and%20deep%20blue%20sky%2C%20tender%20modern%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=ya-tv-still-03&orientation=landscape",
    year: 2024,
    region: "中国香港",
    genres: ["都市", "爱情", "职场"],
    director: "邓伟豪",
    cast: ["何嘉欣", "马俊杰", "张语彤"],
    rating: 7.7,
    releaseDate: "2024-09-10",
    duration: "40分钟/集",
    synopsis:
      "两位在都市中打拼的年轻人因一次意外合租而结缘，事业与感情的拉扯之间，他们学会在现实里守护一份真诚。",
    seasons: 1,
    latestEpisode: 30,
    airStatus: "完结",
  },
  {
    id: "t4",
    type: "tv",
    title: "星海征途",
    poster:
      "https://readdy.ai/api/search-image?query=Space%20opera%20sci-fi%20series%20poster%20of%20a%20starship%20fleet%20sailing%20past%20a%20giant%20orange%20planet%20against%20deep%20blue%20nebula%2C%20epic%20sci-fi%20scale%2C%20high%20detail%20cinematic%20visual&width=400&height=600&seq=ya-tv-poster-04&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Epic%20space%20opera%20series%20still%20of%20a%20crew%20gathered%20on%20a%20starship%20bridge%20watching%20a%20vast%20orange%20planet%20through%20a%20window%2C%20deep%20blue%20starlight%2C%20cinematic%20sci-fi%20scale%2C%20high%20detail&width=1200&height=675&seq=ya-tv-still-04&orientation=landscape",
    year: 2025,
    region: "美国",
    genres: ["科幻", "冒险", "悬疑"],
    director: "Nathan Brooks",
    cast: ["Ethan Cole", "Sophia Lane", "Marcus Reed"],
    rating: 8.5,
    releaseDate: "2025-01-20",
    duration: "50分钟/集",
    synopsis:
      "人类首支远航舰队驶向未知星海，在漫长的征途中，船员们面对的不只是外星文明，还有人性的极限与信任的考验。",
    seasons: 1,
    latestEpisode: 18,
    airStatus: "连载",
  },
  {
    id: "t5",
    type: "tv",
    title: "海港风云",
    poster:
      "https://readdy.ai/api/search-image?query=Business%20drama%20series%20poster%20of%20a%20harbor%20skyline%20at%20sunset%20with%20cargo%20ships%20and%20warm%20orange%20lights%20against%20deep%20blue%20dusk%2C%20powerful%20corporate%20tone%2C%20high%20detail&width=400&height=600&seq=ya-tv-poster-05&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Corporate%20drama%20series%20still%20of%20executives%20in%20a%20glass%20tower%20office%20overlooking%20a%20busy%20harbor%20at%20dusk%2C%20warm%20orange%20sunset%20and%20deep%20blue%20shadows%2C%20tense%20power%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=ya-tv-still-05&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["商战", "剧情", "都市"],
    director: "俞深海",
    cast: ["秦牧川", "叶清荷", "罗志远"],
    rating: 8.0,
    releaseDate: "2024-06-18",
    duration: "44分钟/集",
    synopsis:
      "老牌港口集团在时代转型中风雨飘摇，新一代掌门人在家族恩怨与商业博弈中，寻找一条通往未来的航路。",
    seasons: 1,
    latestEpisode: 40,
    airStatus: "完结",
  },
];